module.exports = __webpack_public_path__ + "static/media/mind_chip.1bb643ca.jpg";